// extracted by mini-css-extract-plugin
module.exports = {"root":"PermitsPage_root__1fjIb"};